import { Route, Redirect } from 'react-router-dom'
import * as React from 'react'
import { auth } from 'firebase/app'
import 'firebase/auth'

class PrivateRoute extends Route {

    public render() {
        return this.canAccess() ? super.render() :
            <Redirect to={{
                pathname: '/login',
                state: { from: this.props.location }
            }} />

    }
    private canAccess(): boolean {
        return auth().currentUser !== null
    }
}

export default PrivateRoute


// WEBPACK FOOTER //
// ./src/helpers/PrivateRoute.tsx